import * as core from '../../../../../../../core'

import { query } from './anticipated-response-of-change-by-department.query'

export const RESOURCE = {
  payload: {
    alias: 'anticipated.response.of.change.by.department',
    description:
      'Stacked bar chart of anticipated response of change by department',
    name: 'Anticipated Response of Change by Department',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
